const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const isAbsoluteUrl = (url: string): boolean => /^https?:\/\//i.test(url);

export const buildApiUrl = (path: string): string => (isAbsoluteUrl(path) ? path : `${API_BASE_URL}${path}`);

export const apiFetch = (path: string, init?: RequestInit): Promise<Response> => {
  const url = buildApiUrl(path);
  return fetch(url, {
    ...init,
    credentials: 'include',
  });
};

export const apiEventSourceUrl = (path: string): string => buildApiUrl(path);

export { API_BASE_URL };







